import type { ICustomControlRequestReadProps } from '../../../interfaces/customControlRequestReadProps';
import { RequestStatus } from '../../../../../../../common/enums/requestStatus';
import { translateKey } from '../../../../../../translate';
import { UserTextParagraph } from '../../../../../elements/common';
import { FormLabel } from '../../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../../elements/forms/InputContainer';
import { RequestMessageContainer } from '../../../../episodes/RequestMessageContainer';

export function PilotReferralSmallV1RequestSummary(props: ICustomControlRequestReadProps) {
    if (!props.request.customControlData.verwijsreden) {
        return null;
    }

    return (
        <>
            <HorizontalFormGroupRead>
                <FormLabel>{translateKey('request.referralReasons')}</FormLabel>
                <InputContainer>
                    <UserTextParagraph>{props.request.customControlData.verwijsreden}</UserTextParagraph>
                </InputContainer>
            </HorizontalFormGroupRead>

            {props.process.status === RequestStatus.completed &&
                props.process.requestMessages &&
                props.process.requestMessages.length > 0 && (
                    <RequestMessageContainer requestMessages={props.process.requestMessages} />
                )}
        </>
    );
}
